<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-19 14:41:24
 * @FilePath: src/views/index/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-11-20 16:06:21
  @Description 首页
-->
<template>
  <div :class="[scope.clsPrefix, { 'page-index--embedded': isEmbedded }]">
    <!-- 头部 -->
    <index-sider v-if="popperShow" :class="`${scope.clsPrefix}_sider`" />
    <index-header
      v-if="!isEmbedded"
      :class="`${scope.clsPrefix}_head`"
    />
    <!-- 主体内容 -->
    <div :class="`${scope.clsPrefix}_body`">
      <index-header-sider
        v-if="!isEmbedded"
        :class="`${scope.clsPrefix}_head_sider`"
      ></index-header-sider>
      <!-- 中心内容 -->
      <index-main :class="`${scope.clsPrefix}_main`" :isEmbedded="isEmbedded" />
    </div>
  </div>
</template>

<script>
// 头部
import IndexHeader from './header/index.vue'
import IndexHeaderSider from './header/headSider.vue'
import IndexSider from './header/sider.vue'
// 中心内容
import IndexMain from './main/index.vue'
import { isCosmoSphere } from '@/utils/env'
export default {
  // 组件名称
  name: 'PageIndex',
  components: {
    IndexHeader,
    IndexHeaderSider,
    IndexSider,
    IndexMain
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'page-index'
      }
    }
  },
  // 计算属性
  computed: {
    // CosmoSphere 客户端（webview 嵌入）时不展示顶部导航栏，也可通过 query embed=1 / webview=1 强制控制
    isEmbedded() {
      return (
        isCosmoSphere() ||
        this.$route.query.embed === '1' || this.$route.query.webview === '1'
      )
    },
    popperShow() {
      return this.$store.state.app.popperShow
    },
    // 是否显示侧边栏
    showAside() {
      return this.$store.state.app.showAside
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {}
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: "page-index";

.#{$class-prefix} {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f8fc;
  // 头部
  &_head {
    height: 48px;
    z-index: 10;
    background-color: #fff;
    box-shadow: 0px 0 10px 0px rgba(0, 0, 0, 0.08);
  }
  // 头部右侧
  &_head_sider {
    position: absolute;
    right: 10px;
    top: 0px;
    z-index: 999;
    height: 48px;
  }
  // 侧边
  &_sider {
    z-index: 999;
  }

  // 主体内容
  &_body {
    display: flex;
    flex: 1;
    // overflow: hidden;
    z-index: 100;
    height: calc(100vh - 48px);
  }

  // webview 嵌入时（隐藏顶部导航栏）主体占满整屏
  &--embedded &_body {
    height: 100%;
  }

  // 中心内容
  &_main {
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    // overflow-y: auto;
  }
}
</style>
